const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


// Get signed URLs for uploads
export const getSignedUrls = async (files = []) => {
    try {
        const token = localStorage.getItem("token");

        const res = await fetch(`${API_BASE_URL}/api/upload/signed-url`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ files }),
        });

        const body = await res.json().catch(() => ({}));

        if (!res.ok || body?.status === false) {
            throw new Error(body?.message || `Failed to get signed URLs: ${res.status}`);
        }

        return body?.data?.uploads || [];
    } catch (err) {
        console.error("Error in getSignedUrls:", err);
        return [];
    }
}


export const viewUrl = async (keyOrUrl = "") => {
    try {
        const token = localStorage.getItem("token");
        if (!keyOrUrl || typeof keyOrUrl !== "string") return null;

        let s3Key = null;

        // Check if it's already a signed URL (contains X-Amz-Signature or Signature)
        if (keyOrUrl.includes('X-Amz-Signature') || keyOrUrl.includes('Signature=')) {
            return keyOrUrl;
        }

        // Check if it's a full S3 URL - extract the key
        if (keyOrUrl.startsWith("http://") || keyOrUrl.startsWith("https://")) {
            // Check if it's an S3 URL
            if (keyOrUrl.includes('.s3.') || keyOrUrl.includes('s3.amazonaws.com')) {
                try {
                    const urlObj = new URL(keyOrUrl);
                    // Extract the path (everything after the domain)
                    // Remove leading slash if present
                    const path = urlObj.pathname.startsWith('/') ? urlObj.pathname.slice(1) : urlObj.pathname;
                    // Remove query parameters from the path
                    s3Key = path.split('?')[0];

                    // If we successfully extracted a key, use it to get signed URL
                    if (s3Key) {
                        console.log('Extracted S3 key from URL:', s3Key);
                    } else {
                        // Couldn't extract key, return original URL
                        return keyOrUrl;
                    }
                } catch (error) {
                    console.error('Failed to parse S3 URL:', error);
                    // Fallback: try to extract manually using regex
                    const match = keyOrUrl.match(/s3[^/]*\/\/[^/]+\/(.+?)(?:\?|$)/);
                    if (match && match[1]) {
                        s3Key = match[1];
                        console.log('Extracted S3 key using regex:', s3Key);
                    } else {
                        // Not an S3 URL or couldn't extract, return original URL
                        return keyOrUrl;
                    }
                }
            } else {
                // Not an S3 URL, return directly
                return keyOrUrl;
            }
        } else {
            // Treat as S3 key directly
            s3Key = keyOrUrl;
        }

        // If we have an S3 key, call the API to get a signed URL
        if (s3Key) {
            const encodedKey = encodeURIComponent(s3Key);

            const res = await fetch(
                `${API_BASE_URL}/api/upload/view-url?key=${encodedKey}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (!res.ok) {
                console.error("Failed to fetch signed view URL:", res.status);
                throw new Error("Could not fetch signed view URL");
            }

            const data = await res.json();

            if (!data?.status || !data?.data?.url) {
                throw new Error("Invalid signed URL response");
            }

            return data.data.url;
        }

        return null;
    } catch (err) {
        console.error("Error in viewUrl:", err);
        return null;
    }
}


// Upload file → S3 PUT request
export const uploadFileToS3 = async (uploadUrl, file, fileType) => {
    try {
        const res = await fetch(uploadUrl, {
            method: "PUT",
            headers: {
                "Content-Type": fileType,
            },
            body: file,
        });

        if (!res.ok) {
            throw new Error(`Failed to upload file to S3: ${res.status}`);
        }

        return true;
    } catch (err) {
        console.error("Error in uploadFileToS3:", err);
        return false;
    }
}
